<template>
  <div id="sidebar-category" class="col-xs-12 col-sm-12 col-md-12 col-lg-10">
    <div class="box_style_2 rightcontent" id="myOrdersDiv">
      <h2 class="inner">My Orders</h2>
      <div class="row">
        <div class="col-md-12" id="myOrders" style="padding: 0"></div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import * as render from "../utils/render";

export default {
  name: "MyOrder",
  created() {
    this.$store.dispatch("getMyOrders").then((myOrders) => {
      myOrders.forEach((order) => {
        render.myOrders(order);
        let button_open = "#openOrder_" + order.order_no;
        let button_close = "#closeOrder_" + order.order_no;
        let button_repeat = "#repeatOrder_" + order.order_no;
        let button_ti = "#taxInvoiceOrder_" + order.order_no;
        $(document).on("click", button_open, ($event) => {
          this.showHideOrderDetails($event, "open");
        });
        $(document).on("click", button_close, ($event) => {
          this.showHideOrderDetails($event, "close");
        });
        $(document).on("click", button_repeat, ($event) => {
          this.repeatOrder($event, order.order_no);
        });
        $(document).on("click", button_ti, ($event) => {
          this.showTaxInvoice($event, order.order_no);
        });
        order.order_menu.forEach((menu) => {
          render.menuItemDetails(menu, order.order_no);
        });
      });
    }),
      this.$store.watch((getters) => getters.open_menu);
  },
  computed: {
    ...mapGetters(["open_menu", "myOrders"]),
  },
  mounted() {
    var heightDoc = $(".rightcontent").height();
    $(".sidemenu").css("min-height", heightDoc);
    //   console.log(" My Order " + this.myOrders[0][0].order_menu.menu_name)
  },
  ready() {
    $("a#1").addClass("active");
  },
  methods: {
    showHideOrderDetails(event, type) {
      if (type === "open") {
        let id = $(event.target).attr("data-id");
        $("#" + id).css({ display: "block" });
        $("#openOrder_" + id).css({ display: "none" });
        $("#closeOrder_" + id).css({ display: "inline-block" });
      } else {
        let id = $(event.target).attr("data-id");
        $("#" + id).css({ display: "none" });
        $("#openOrder_" + id).css({ display: "inline-block" });
        $("#closeOrder_" + id).css({ display: "none" });
      }
    },
    openMenu(event) {
      this.$store.dispatch("openMenu", event);
    },
    repeatOrder(event, orderNo) {
      $("#repeatOrder_" + orderNo).html("Please Wait ...");
      this.$store.dispatch("repeatOrder", orderNo).then((rdata) => {
        $("#repeatOrder_" + orderNo).html("Repeat Order");
        this.$fire({
          html: "<b>" + rdata.message + "</b>",
          title: "Success",
          type: "success",
          timer: 3000,
        });
        this.$router.push("/").catch((err) => {
          console.log(err.message);
        });
      });
    },
    showTaxInvoice(event, orderNo) {
      $("#taxInvoiceOrder_" + orderNo).html("Please Wait ...");
      this.$store.dispatch("taxInvoice", orderNo).then((rdata) => {
        $("#taxInvoiceOrder_" + orderNo).html("Tax Invoice");
        let htm = render.getTaxInvoiceView(rdata.orders);
        this.$fire({
          width: "12cm",
          height: "6cm",
          html: htm,
          showCloseButton: false,
          showConfirmButton: false,
        });
      });
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.thumb_menu_list {
  height: 60px;
}
.table > thead > tr > td {
  padding: 3px;
}
.rightcontent {
  background: rgb(255, 255, 255);
  padding: 30px 20px;
  min-height: auto !important;
}
</style>
